//@flow
import React from 'react';
import {Switch, Route} from 'react-router-dom';
import {makeStyles} from '@material-ui/core';

import BlogForm from './BlogForm';
import BlogSummary from './BlogSummaryPage';
import {useInitializeBlogCategories} from '../utils/blog-category';
import {useInitializeBlogPosts} from '../utils/blog-post';
import {useInitializeBlogAuthors} from '../utils/blog-author';
import BlogCategoryModal from './CategoryModal';

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: '1rem',
  },
}));

export default function Blog() {
  const classes = useStyles();
  useInitializeBlogCategories();
  useInitializeBlogPosts();
  useInitializeBlogAuthors();

  return (
    <div className={classes.root}>
      <Switch>
        <Route exact path="/my-store/blog" component={BlogSummary}></Route>
        <Route path="/my-store/blog/:blogId" component={BlogForm} />
      </Switch>
      <BlogCategoryModal />
    </div>
  );
}
